import { useFileUpload, useCameraCreation } from '@/hooks';
import { useSourceCreationStore } from '@/stores/source-creation.store';
import {
    FileUploadStatus,
    isFileUploadItemBeingPrepared,
} from '@/types/source-creation';
import {
    FileUploadDrawerContent,
    CameraCreationDrawerContent,
} from './components';

export function NewSourceStatusDrawer() {
    useFileUpload();
    useCameraCreation();

    const fileItems = useSourceCreationStore((state) => state.fileItems);
    const isFileExpanded = useSourceCreationStore(
        (state) => state.fileDrawerExpanded,
    );
    const setFileExpanded = useSourceCreationStore(
        (state) => state.setFileDrawerExpanded,
    );
    const clearAllFiles = useSourceCreationStore(
        (state) => state.clearAllFiles,
    );
    const updateFileItem = useSourceCreationStore(
        (state) => state.updateFileItem,
    );
    const cameraItems = useSourceCreationStore((state) => state.cameraItems);
    const isCameraExpanded = useSourceCreationStore(
        (state) => state.cameraDrawerExpanded,
    );
    const setCameraExpanded = useSourceCreationStore(
        (state) => state.setCameraDrawerExpanded,
    );
    const clearAllCameras = useSourceCreationStore(
        (state) => state.clearAllCameras,
    );

    const drawerFileItems = fileItems.filter(isFileUploadItemBeingPrepared);
    const hasDrawerFileItems = drawerFileItems.length > 0;
    const hasCameraItems = cameraItems.length > 0;

    if (!hasDrawerFileItems && !hasCameraItems) return null;

    const handleRetry = (itemId: string) => {
        updateFileItem(itemId, {
            status: FileUploadStatus.PENDING,
            progress: 0,
            error: undefined,
            retryCount: 0,
            createdSourceId: undefined,
            sourceStatus: undefined,
            sourceProgress: undefined,
        });
    };

    if (hasCameraItems) {
        return (
            <CameraCreationDrawerContent
                cameraItems={cameraItems}
                isExpanded={isCameraExpanded}
                setExpanded={setCameraExpanded}
                onClear={clearAllCameras}
            />
        );
    }

    return (
        <FileUploadDrawerContent
            fileItems={drawerFileItems}
            isExpanded={isFileExpanded}
            setExpanded={setFileExpanded}
            onClear={clearAllFiles}
            onRetry={handleRetry}
        />
    );
}
